import { useEffect, useState } from "react";

// --- Общий координатор загрузки -------------------------------------------
// Каждый useFetch на время своего запроса увеличивает счётчик активных
// запросов. Homepage подписывается на него и снимает прелоадер только когда
// счётчик дошёл до 0 — то есть когда ВСЕ секции получили данные и высота
// страницы стабилизировалась. Это и убирает "подскок" WorkSection: контент
// показывается целиком и сразу в финальной раскладке, а не впрыгивает
// секциями вразнобой.
let pending = 0;
const listeners = new Set();
const emit = () => {
  for (const listener of listeners) listener(pending);
};

export function subscribePending(listener) {
  listeners.add(listener);
  listener(pending); // сразу отдаём текущее значение
  return () => {
    listeners.delete(listener);
  };
}

const useFetch = (url) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    let settled = false;

    pending += 1;
    emit();

    // гарантированно уменьшаем счётчик ровно один раз (успех, ошибка или
    // размонтирование) — иначе прелоадер мог бы зависнуть навсегда
    const settle = () => {
      if (settled) return;
      settled = true;
      pending = Math.max(0, pending - 1);
      emit();
    };

    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetch(url);
        const json = await res.json();
        if (alive) {
          setData(json);
          setLoading(false);
        }
      } catch (err) {
        if (alive) {
          setError(true);
          setLoading(false);
        }
      } finally {
        settle();
      }
    };

    fetchData();

    return () => {
      alive = false;
      settle();
    };
  }, [url]);

  return { loading, error, data };
};

export default useFetch;
